exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button_datapicker_reports {\n  height: 40px;\n  justify-content: space-between;\n  display: flex;\n  padding: 10px;\n  width: 100%;\n  border: 0.5px solid #c1c1c1;\n  font-size: 14px;\n  font-weight: 400;\n  border-radius: 3px;\n  background: #fff;\n  color: #333;\n}\n.icon_button_datapicker_reports {\n  color: #858585;\n  width: 20px;\n  opacity: 0px;\n}\n.button_filter_reports {\n  height: 40px;\n  width: 39px;\n  background: #39acb5;\n  color: #1a232;\n}\n.Select-placeholder {\n  color: #333;\n}\n", ""]);

// exports
